import type {
  IOrganizationMembershipHistoryItemDto,
  IUserMembershipHistoryItemDto
} from '@treneo/models';
import { convertDateToIsoString } from '@treneo/shared/utils';

import type { OrganizationMembershipHistoryRow } from '../types';

const toRowBase = (dto: {
  id: string;
  isTrainer: boolean;
  createdAt: Date;
  addedByUserEmail?: string;
  deletedAt?: Date;
  deletedByUserEmail?: string;
  isDeleted: boolean;
  assignmentChangeSource: number;
  removalChangeSource?: number;
}): Omit<OrganizationMembershipHistoryRow, 'userEmail' | 'organizationName'> => ({
  id: dto.id,
  isTrainer: dto.isTrainer,
  createdAt: convertDateToIsoString(dto.createdAt) ?? null,
  addedByUserEmail: dto.addedByUserEmail ?? null,
  deletedAt: dto.deletedAt == null ? null : convertDateToIsoString(dto.deletedAt),
  deletedByUserEmail: dto.deletedByUserEmail ?? null,
  isDeleted: dto.isDeleted,
  assignmentChangeSource: dto.assignmentChangeSource,
  removalChangeSource: dto.removalChangeSource ?? null
});

export const mapOrganizationMembershipHistoryItemToRow = (
  dto: IOrganizationMembershipHistoryItemDto
): OrganizationMembershipHistoryRow => ({
  ...toRowBase(dto),
  userEmail: dto.userEmail ?? null,
  organizationName: null
});

export const mapUserMembershipHistoryItemToRow = (
  dto: IUserMembershipHistoryItemDto
): OrganizationMembershipHistoryRow => ({
  ...toRowBase(dto),
  userEmail: null,
  organizationName: dto.organizationName ?? null
});
